import { connect } from 'react-redux';
import TableBody from '../../components/Table/BodyRedux';

export default connect(
    state => ({
        total: state.users.list.length
    }),
    null
)(TableBody);